import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function timeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const valid = /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9])$/.test(control.value);
    return !valid ? { invalidTime: { value: control.value, msg: 'Nevalidný časový formát.' } } : null;
  };
}
